import React, { useEffect, useState } from 'react';
import { preferenceService } from '../../services/preferences';
import ActivityLoader from '../ActivityLoader';
import { Card, CardContent, Container } from '@mui/material';
import { CustomToast } from '../../common/Methodcommon';
import _ from 'lodash';
import { useNavigate } from 'react-router';
import { useList } from '../../api/react-query';
import { Backdrop } from '../../components';
import { EMPortal, MainMenuItems } from '../../common/constants';
import company from '../../api/company';

const styles = {
  box: {
    width: 700,
    height: 700,
    backgroundColor: 'transparent',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    left: '50%',
    top: '51%',
    transform: 'translate(-50%, -50%)',
  },
  text: {
    fontSize: 34,
    fontWeight: 200,
    color: '#7C0E6F',
    marginLeft: 20,
  },
};
export default function ViewController(props) {
  const navigate = useNavigate();

  let menuItems = MainMenuItems();

  const [employeeId, setEmployeeId] = useState(null);

  const { isLoading } = useList(
    'auth/employee-portal-token',
    {},
    {
      enabled: !!employeeId,
      onSuccess: async (data) => {
        const res = await company.logout();

        if (res) {
          window.location.href = `${EMPortal}/gotoEmployee?id=${employeeId}&portal=true&token=${data?.data.portalToken
            }&locale=${localStorage.getItem('applang')}`;

          setEmployeeId(null);
          localStorage.clear();
        }
      },
    },
  );

  useEffect(async () => {
    const user_id = localStorage.getItem('__active__user__id');
    const company_id = localStorage.getItem('__current_company_id');
    const user_info = localStorage.getItem('__user__info');

    const activeBUInfo = JSON.parse(
      localStorage.getItem('__active__BU__info'),
    );
    const activeUserInfo = JSON.parse(
      localStorage.getItem('__active__user__role'),
    );

    let url_default = '/company/dashboard';
    const parsed = JSON.parse(user_info);
    const emp_id = parsed?.currentRole?.emp_id;

    if (!activeUserInfo) {
      navigate('/login');
      return;
    }

    if (activeUserInfo?.acl?.length > 0) {
      let url_default = '';

      try {
        const preferences = await preferenceService.getPreference(user_id, company_id);
        const favPreference = _.find(preferences, (pref) => pref.preference_name === 'FAV_SCREEN');

        if (favPreference?.value) {
          const favScreenName = favPreference.value;

          // menu entry for the fav screen (for its link/mainMenu)
          const favScreenMenu = _.find(menuItems, (d) => d.link === favScreenName && d?.link !== null);

          // does the user actually have permission for this screen?
          const favScreenPerm = _.find(activeBUInfo['perms'], (perm) => perm?.screen_name === favScreenMenu?.title);

          if (favScreenPerm && favScreenMenu) {
            url_default = favScreenMenu.link ? favScreenMenu.link : favScreenMenu.mainMenu;
            window.location.replace(url_default);
            return;
          }
        }
      } catch (err) {
        CustomToast('error', err);
      }
      const screen = activeUserInfo.acl[0]['screen_name'];
      const activeBUPerm = _.find(activeBUInfo['perms'], (screen) => {
        return screen?.screen_name === screen
      });
      const screens = _.find(menuItems, function (d) {
        return d.title === screen && d?.link !== null;
      });

      if (activeBUPerm?.length > 0 && screens) {
        url_default = screens.link ? screens.link : screens.mainMenu;

        window.location.replace(url_default);
      } else {
        const activeScreen = activeBUInfo?.perms?.[0]?.screen_name || null;
        const screenurl = _.find(menuItems, function (d) {
          return d.title === activeScreen && d?.link !== null;
        });
        url_default = screenurl.link ? screenurl.link : screens.mainMenu;

        window.location.replace(url_default);
      }
    } else if (!parsed?.isAdmin) {
      console.log('parse', parsed);
      setEmployeeId(emp_id);
    } else {
      if (parsed?.isAdmin) {
        console.log('admin', parsed);
        preferenceService
          .getPreference(user_id, company_id)
          .then((res) => {
            const url = _.find(res, function (df) {
              return df.preference_name === 'FAV_SCREEN';
            });
            // const screens = _.find(menuItems, function (d) {
            //   return d.link === url.value;
            // });
            // const urlhasaccess = _.map(parsed?.access_control, function (access_cont) {
            //   const roleScreenAccess = _.find(access_cont?.acl, function (access) {
            //     return access?.screen_name === screens.title;
            //   });
            //   return roleScreenAccess;
            // }).filter(item => item !== undefined && item !== null);
            if (url) {
              window.location.replace(url.value);
            } else {
              window.location.replace(url_default);
            }
          })
          .catch((err) => {
            CustomToast('error', err);
          });
      } else {
        navigate('/login');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return <Backdrop open />;
  }

  return (
    <div>
      <Container>
        <Card elevation={0} style={styles.box}>
          <CardContent>
            <ActivityLoader />
          </CardContent>
        </Card>
      </Container>
    </div>
  );
}
